import React from 'react';
import PropTypes from 'prop-types';
import { processQuestionText } from '../../../../utils/shared/probeDetailUtils';
import { getQuestionText, getQuestion } from './TQVMProbeDetails';
import { ICON } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const GAP = '______';

const FITBProbeDetails = ({ result, content: { questions, correctResponses } }) => (
    <div className="fitb">
        <ol className="question-list">
            {result.responses.map(({ item_id: questionId, response_id: responseId }) => {
                const question = getQuestion(questions, questionId);
                const { possible_responses: possibleResponses } = question;

                return (
                    <div key={generateReactKey(questionId)} className="assessment-row">
                        <li>{processQuestionText(getQuestionText(question), GAP)}</li>
                        <ol type="a" className="answers-container">
                            {possibleResponses.map(({ id, text }) => (
                                <li key={generateReactKey(id)}>
                                    <span
                                        className={`answer ${id === responseId ? 'correct' : ''}`}
                                    >
                                        {text}
                                    </span>
                                    {correctResponses[questionId] === id && ICON.DONE}
                                </li>
                            ))}
                        </ol>
                    </div>
                );
            })}
        </ol>
    </div>
);

FITBProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
};

export default FITBProbeDetails;
